<div class="modal-header align-items-center">
  <div class="col">
    <h4 class="modal-title">
      @if (isAddOperation) {
        <span translate>Add widget</span>
      }
      @if (!isAddOperation) {
        <span translate>Edit widget</span>
      }
    </h4>
  </div>
  <div class="col-auto">
    <button (click)="onClose()" aria-label="Close" class="close" type="button">
      <span aria-hidden="true" class="fa-solid fa-xmark"></span>
    </button>
  </div>
</div>
<div class="modal-body">
  <form>
    <div [ngClass]="{'d-none' : isChartSetting}">

      <div class="form-group mb-0">
        <label class="mb-1" translate>Widget type</label>

        <div class="form-row">

          @for (type of usableUserDefinedPageChartTypes; track type) {
            <scitis-widget-content-type-selector
              (widgetSelectorChange)="onSelectWidgetContentType($event)"
              [isDisabled]="isDisabledSelector(type)"
              [disableHint]="getHintText(type)"
              [widgetType]="type"
              class="col-12 col-sm-6 col-md-4 my-1">
            </scitis-widget-content-type-selector>
          }

        </div>
      </div>
    </div>

    <div [ngClass]="{'d-none' : !isChartSetting}">

      <div class="chart-config-head">

        @if (isAddOperation) {
          <button (click)="toggleChartSettings()" class="btn btn-outline-primary btn-sm mr-2">
            <span class="fa-solid fa-chevron-left"></span>
            <span translate>Back</span>
          </button>
        }

        <div class="h4">
          <span [innerText]="userDefinedWidget.widgetDetails.widgetName" class="truncate"></span>
          @if (!userDefinedWidget.widgetDetails.widgetName) {
            <span translate>New widget</span>
          }
        </div>

        <div class="h5 font-weight-normal mb-0">
          <span [class]="widgetTypeCssClass" class="mr-2"></span>
          <span [innerText]="widgetTypeTitle"></span>
          <span class="ml-1" translate>settings</span>
        </div>
      </div>

      <div class="form-group">
        <label translate>Name</label>
        <scitis-required-field-indicator></scitis-required-field-indicator>
        <input [(ngModel)]="userDefinedWidget.widgetDetails.widgetName" [ngClass]="{
                      'is-invalid': isWidgetNameNotSet || widgetNameIsUsed || widgetNameTooLong,
                       'is-valid':!isWidgetNameNotSet && !widgetNameIsUsed && !widgetNameTooLong
                       }"
          [placeholder]="'Add widget name ...'|translate"
          class="form-control"
          name="widgetName" required
          type="text">
          @if (isWidgetNameNotSet || widgetNameIsUsed || widgetNameTooLong) {
            <div class="invalid-feedback">
              @if (isWidgetNameNotSet) {
                <span translate>Widget name is not set!</span>
              }
              @if (widgetNameIsUsed) {
                <span translate>Widget name is already used!</span>
              }
              @if (widgetNameTooLong) {
                <span translate>Widget name is too long!</span>
              }
            </div>
          }
        </div>
        <!-- LINE  -->
        <scitis-line-widget-settings
          (isConfigurationValid)="isLineWidgetConfigurationValid($event)"
          [machineSignals]="machineSignalsArray"
          [userDefinedWidget]="userDefinedWidget"
          [isTemplateWidget]="isTemplateWidget">
        </scitis-line-widget-settings>

        <!-- TEXT  -->
        <scitis-text-widget-configuration
          (isConfigurationValid)="isTextWidgetConfigurationValid($event)"
          [machineSignals]="machineSignalsArray"
          [machine]="machine"
          [userDefinedWidget]="userDefinedWidget"
          [isTemplateWidget]="isTemplateWidget">
        </scitis-text-widget-configuration>

        <!-- BAR -->
        <scitis-bar-widget-configuration
          (isConfigurationValid)="isBarWidgetConfigurationValid($event)"
          [machineSignals]="machineSignalsArray"
          [userDefinedWidget]="userDefinedWidget"
          [isTemplateWidget]="isTemplateWidget">
        </scitis-bar-widget-configuration>

        <!-- PIE -->
        <scitis-pie-widget-configuration
          (isConfigurationValid)="isPieWidgetConfigurationValid($event)"
          [machineSignals]="machineSignalsArray"
          [userDefinedWidget]="userDefinedWidget"
          [isTemplateWidget]="isTemplateWidget">
        </scitis-pie-widget-configuration>

        <!-- GAUGE  -->
        <scitis-gauge-widget-configuration
          (isConfigurationValid)="isGaugeConfigurationValid($event)"
          [machineSignals]="machineSignalsArray"
          [userDefinedWidget]="userDefinedWidget"
          [isTemplateWidget]="isTemplateWidget">
        </scitis-gauge-widget-configuration>

        <!-- MAP -->
        <scitis-map-widget-configuration
          (isConfigurationValid)="isMapWidgetConfigurationValid($event)"
          [machine]="machine"
          [userDefinedWidget]="userDefinedWidget">
        </scitis-map-widget-configuration>

        <!-- IMAGE -->
        @if (userDefinedWidget.widgetDetails.widgetType === UserDefinedWidgetType.IMAGE) {
          <scitis-image-widget-configuration
            (isConfigurationValid)="isImageConfigurationValid($event)"
            [machine]="machine"
            [userDefinedWidget]="userDefinedWidget">
          </scitis-image-widget-configuration>
        }

        <!-- STATUS EVENT -->
        <scitis-status-event-widget-configuration
          [widgetType]="userDefinedWidget.widgetDetails.widgetType"
          [machine]="machine"
          [userDefinedWidget]="userDefinedWidget"
          (isConfigurationValid)="isStatusWidgetConfigurationValid($event)">
        </scitis-status-event-widget-configuration>

        <!-- COMMAND -->
        @if (userDefinedWidget.widgetDetails.widgetType === UserDefinedWidgetType.COMMAND) {
          <scitis-command-widget-configuration
            (isConfigurationValid)="isCommandWidgetConfigurationValid($event)"
            (hasGenericGatewaySelected)="doesCommandWidgetHaveGenericGatewaySelected($event)"
            [machineSignals]="machineSignalsArray"
            [machine]="machine"
            [userDefinedWidget]="userDefinedWidget"
            [isTemplateWidget]="isTemplateWidget">
          </scitis-command-widget-configuration>
        }

      </div>

    </form>
  </div>
  <scitis-modal-footer (cancelButtonPressed)="onCancel($event)"
    (okButtonPressed)="onSave($event)"
    [cancelButtonText]="'Cancel'|translate"
    [disableOkButton]="shouldDisableSaveButton()"
    [okButtonText]="'Save'|translate"
    [showRequiredFieldsIndicator]="true">
  </scitis-modal-footer>
